import { useCallback, useReducer } from "react";

// Pure state machine for the 越線 add-only tool button. Framework concerns
// (canvas click routing, POST, focusing the new line) all live in
// FloorPlanModal/index.js -- this hook only tracks: is adding on, how many
// points has the operator placed (plane needs 2; line/tunnel create on the
// first click and never accumulate a second), and the rubber-band preview
// point that follows the mouse after point 1 (plane only).
const initialState = { active: false, points: [], previewPoint: null };

function reducer(state, action) {
  switch (action.type) {
    case "START":
      return { active: true, points: [], previewPoint: null };
    case "CANCEL":
      return { active: false, points: [], previewPoint: null };
    case "ADD_POINT":
      if (!state.active) return state;
      return {
        active: true,
        points: [...state.points, action.point],
        previewPoint: null,
      };
    case "SET_PREVIEW":
      if (!state.active) return state;
      return { ...state, previewPoint: action.point };
    case "COMPLETE":
      return { active: false, points: [], previewPoint: null };
    case "TOGGLE":
      return state.active
        ? { active: false, points: [], previewPoint: null }
        : { active: true, points: [], previewPoint: null };
    default:
      return state;
  }
}

export const useTripwireAddMode = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const start = useCallback(() => dispatch({ type: "START" }), []);
  const cancel = useCallback(() => dispatch({ type: "CANCEL" }), []);
  const addPoint = useCallback(
    (point) => dispatch({ type: "ADD_POINT", point }),
    [],
  );
  const setPreviewPoint = useCallback(
    (point) => dispatch({ type: "SET_PREVIEW", point }),
    [],
  );
  const complete = useCallback(() => dispatch({ type: "COMPLETE" }), []);
  const toggle = useCallback(() => dispatch({ type: "TOGGLE" }), []);

  return {
    active: state.active,
    points: state.points,
    previewPoint: state.previewPoint,
    start,
    cancel,
    addPoint,
    setPreviewPoint,
    complete,
    toggle,
  };
};

/**
 * Hint-bar text for the given layout/point count. Plane is a two-click flow
 * (1/2 -> 2/2); line/tunnel place the whole lane gate on a single click.
 */
export const getTripwireAddHint = (layoutType, pointsCount) => {
  if (layoutType !== "plane") {
    return "點擊車道上的位置放置越線閘道・Esc 取消";
  }
  return pointsCount >= 1
    ? "點擊放置終點（2/2）・Esc 取消"
    : "點擊放置起點（1/2）";
};
